import { Pipe, PipeTransform } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faCogs } from '@fortawesome/free-solid-svg-icons';

@Pipe({
    name: 'docBoxListIcon',
    standalone: false,
})
export class DocBoxListIconPipe implements PipeTransform {
    public transform(value: string): IconDefinition {
        switch (value) {
            default:
                return faCogs;
        }
    }
}
